import utils from '../utils';

const NS = 'ShopProductBlock';
const CLS = 'shopProductBlock';

export class ShopProductBlock {
	constructor(element) {
		// $el is the widget node return by the loadShopProductBlock function
		this.$el = $(element);
		this.$title = this.$el.find(`.${CLS}-title`);
		this.$subtitle = this.$el.find(`.${CLS}-subtitle`);
		this.$productUrl = this.$el.find(`.${CLS}-url`);
		this.$shopUrl = this.$el.find(`.${CLS}-cover-shopnow`);
		this.$bgImg = this.$el.find(`.${CLS}-background`);
		this.$certifiedIcon = this.$el.find(`.${CLS}-certifiedIcon`);

		this.id = this.$el.data('id');
		this.prodApi = this.$el.data('prodApi');
		this.getValues();
	}
	getValues() {
		const options = utils.getApiDefaultOptions();
		fetch(`${this.prodApi}?id=${encodeURIComponent(this.id)}`, options).then((response) => {
			return response.json();
		}).then((json) => {
			this.featureProd = json;
			//replace the data into the corresponding location
			this.$bgImg.css("background-image", "url(" + this.featureProd.image + ")");
			this.$productUrl.attr("href", this.featureProd.url);
			this.$shopUrl.attr("href", this.featureProd.url);
			if (this.featureProd.designers && this.featureProd.designers.length) {
				this.$title.html(this.featureProd.designers[0]);
			}
			else{
				this.$title.html(" ")
			}
			this.$subtitle.html(this.featureProd.title);
			// check if this product is woolmark certified
			if(this.featureProd.isCertified){
				this.$certifiedIcon.css("display", "block");
			}
		});
	}
}
